import React, { useState, useEffect } from "react";
import {
  makeStyles,
  Box,
  Button,
  Container,
  TextField,
  Paper,
  Typography,
} from "@material-ui/core";
import Page from "src/components/Page";
import actions from "src/duck/global/actions";
import { connect } from "react-redux";
import KmFilteredTable from "src/components/common/KmFilteredTable";
import Toolbar from "./Toolbar";
import {
  apiEndpoints,
  apiPutRequest,
  apiDeleteRequest,
  apiGetByIdRequest,
} from "src/utils/api/api";
import {
  addCreatedAndUpdatedFields,
  addVoteStatisticField,
} from "src/utils/utils";
import IconButton from "@material-ui/core/IconButton";
import EditIcon from "@material-ui/icons/Edit";
import Tooltip from "@material-ui/core/Tooltip";
import { NavLink as RouterLink } from "react-router-dom";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useTheme } from "@material-ui/core/styles";
import RestoreIcon from "@material-ui/icons/Restore";
import { kmMessages } from "src/constant/Messages";
import KmTabPanel from "src/components/common/KmTabPanel";
import TabsNavBar from "../TabsNavBar";
import ReasonTooltip from "../ReasonTooltip";
import SearchIcon from "@material-ui/icons/Search";
import DescriptionIcon from "@material-ui/icons/Description";
import KmPageTitle from "src/components/layout/KmPageTitle";
import { fillMissingTags } from "src/utils/utils";

const restoreResonMaxLength = 2000;

const formValidation = {
  required: kmMessages.error.form_validation.field_required,
  maxLength: `${kmMessages.error.form_validation.field_maxlengthnum}`,
};

const useStyles = makeStyles((theme) => ({
  root: {
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },
  massagebox: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  title: {
    marginLeft: theme.spacing(3.5),
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    flexGrow: 1,
  },
}));

const RowButtons = (row, customHandlers, ...rest) => {
  return (
    <Box>
      {!row.documentNotApplicable && row.documentStructNodeId ? (
        <Tooltip title="Dokumenty">
          <IconButton
            aria-label="dokumenty"
            component={RouterLink}
            to={`/dokumenty/${row.documentStructNodeId}`}
          >
            <DescriptionIcon />
          </IconButton>
        </Tooltip>
      ) : (
        <></>
      )}
      <Tooltip title="Podgląd">
        <IconButton
          aria-label="podgląd"
          component={RouterLink}
          to={`/zarzadzanieglosowania/podgladglosowania/${row.id}`}
        >
          <SearchIcon />
        </IconButton>
      </Tooltip>
      <Tooltip title="Wznów">
        <IconButton
          aria-label="wznów"
          onClick={() => customHandlers.restoreHandler(row)}
        >
          <RestoreIcon />
        </IconButton>
      </Tooltip>
    </Box>
  );
};

const Votings = ({ enableGlobalLoader, disableGlobalLoader, setLogoutUser }) => {
  const classes = useStyles();

  const [rows, setRows] = useState([]);
  const [reloadCounter, setReloadCounter] = useState(0);
  const [selectedRowIds, setSelectedRowIds] = useState([]);
  const [dialogOpen, setOpen] = useState(false);
  const [dialogRestoreOpen, setRestoreOpen] = useState(false);
  const [restoredVoting, setRestoredVoting] = useState(null);
  const [restoreReason, setRestoreReason] = useState(null);
  const [restoreReasonError, setRestoreReasonError] = useState(null);

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  useEffect(() => {
    enableGlobalLoader();
    apiGetByIdRequest(apiEndpoints.getManagmentVotings.path, "canceled", true)
      .then((data) => {
        disableGlobalLoader();
        setRows(
          addVoteStatisticField(
            addCreatedAndUpdatedFields(
              data,
              "createdBy",
              "createdAt",
              "updatedBy",
              "updatedAt",
              ", "
            )
          )
        );
      })
      .catch((error) => {
        disableGlobalLoader();
      });
    return () => {};
  }, [reloadCounter]);

  useEffect(() => {
    setTimeout(fillMissingTags(), 1000);
    return () => {};
  }, []);

  const restoreHandler = (row) => {
    setRestoredVoting(row);
    handleClickRestoreOpen(row);
  };

  const headCells = [
    {
      id: "btns",
      kmUdField: false,
      numeric: false,
      disablePadding: false,
      searchable: false,
      sortable: false,
      customHandlers: { restoreHandler },
      component: RowButtons,
      width: "10%",
    },{
      id: "title",
      numeric: false,
      disablePadding: false,
      fieldName: "title",
      sortable: true,
      main: true,
      label: "Tytuł głosowania",
      width: "25%",
    },
    {
      id: "startsAt",
      numeric: false,
      disablePadding: false,
      fieldName: "startsAt",
      sortable: true,
      main: false,
      label: "Data rozpoczęcia",
      width: "8%",
    },
    {
      id: "endsAt",
      numeric: false,
      disablePadding: false,
      fieldName: "endsAt",
      sortable: true,
      main: false,
      label: "Data zakończenia",
      width: "8%",
    },
    {
      id: "statistic",
      numeric: false,
      disablePadding: false,
      fieldName: "statistic",
      isHtml: true,
      sortable: false,
      main: false,
      label: "Statystyka",
      width: "18%",
    },
    {
      id: "created",
      fieldName: "createdAt",
      fieldName2: "createdBy",
      kmUdField: true,
      numeric: false,
      disablePadding: false,
      sortable: true,
      searchable: true,
      label: "Kiedy i kto utworzył",
      width: "8%",
    },
    {
      id: "updated",
      fieldName: "updatedAt",
      fieldName2: "updatedBy",
      kmUdField: true,
      numeric: false,
      disablePadding: false,
      sortable: true,
      searchable: true,
      label: "Kiedy i kto zmodyfikował",
      width: "8%",
    },
    {
      id: "actionReason",
      numeric: false,
      disablePadding: false,
      sortable: true,
      component: ReasonTooltip,
      label: "Uzasadnienie",
      width: "15%",
    }
  ];

  const onSelectedRowIdsChanged = (viewSelectedRowIds) => {
    setSelectedRowIds(viewSelectedRowIds);
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleDelete = () => {
    enableGlobalLoader();
    setOpen(false);
    apiDeleteRequest(apiEndpoints.deleteVotings.path, selectedRowIds, true)
      .then((data) => {
        disableGlobalLoader();
        setReloadCounter(reloadCounter + 1);
      })
      .catch((error) => {
        disableGlobalLoader();
      });
  };

  const handleClickRestoreOpen = () => {
    setRestoreOpen(true);
  };

  const handleRestoreDialogClose = () => {
    setRestoreOpen(false);
  };

  const handleRestore = () => {
    enableGlobalLoader();

    if (restoreReason?.length > 0) {
      if (restoreReason.length > restoreResonMaxLength) {
        setRestoreReasonError(
          formValidation.maxLength.replaceAll("{maxlen}", restoreResonMaxLength)
        );
      } else {
        if (restoredVoting) {
          apiPutRequest(
            apiEndpoints.setVotingStatus.path,
            {
              id: restoredVoting.id,
              action: "restore",
              reason: restoreReason,
            },
            true
          )
            .then((data) => {
              disableGlobalLoader();
              setReloadCounter(reloadCounter + 1);
              setRestoreOpen(false);
            })
            .catch((error) => {
              disableGlobalLoader();
              if (error.response && error.response.status === 401) {
                setLogoutUser();
              }
            });
        } else {
        }
      }
    } else {
      setRestoreReasonError(formValidation.required);
      disableGlobalLoader();
    }
  };

  const handleRestoreReasonChange = (event) => {
    if (event.target.value.length > restoreResonMaxLength) {
      setRestoreReasonError(
        formValidation.maxLength.replaceAll("{maxlen}", restoreResonMaxLength)
      );
    } else {
      setRestoreReasonError(null);
    }
    setRestoreReason(event.target.value);
  };

  return (
    <Page className={classes.root} title="Głosowania anulowane">
      <KmPageTitle>Głosowania</KmPageTitle>
      <Container maxWidth={false}>
        <Paper>
          <TabsNavBar value={3} />
          <KmTabPanel value={3} index={3}>
            <Page className={classes.root}>
              <Container maxWidth={false}>
                <KmFilteredTable
                  markable={false}
                  headCells={headCells}
                  rows={rows}
                  onSelectedRowIdsChange={onSelectedRowIdsChanged}
                />
                <Dialog
                  fullScreen={fullScreen}
                  open={dialogOpen}
                  onClose={handleClose}
                  aria-labelledby="responsive-dialog-title"
                >
                  <DialogTitle id="responsive-dialog-title">
                    {"Usuwanie głosowań"}
                  </DialogTitle>
                  <DialogContent>
                    <DialogContentText>
                      Czy na na pewno chcesz usunąć zaznaczone elementy?
                    </DialogContentText>
                  </DialogContent>
                  <DialogActions>
                    <Button autoFocus onClick={handleClose} color="primary">
                      Nie
                    </Button>
                    <Button onClick={handleDelete} color="primary" autoFocus>
                      Tak
                    </Button>
                  </DialogActions>
                </Dialog>
                <Dialog
                  fullScreen={fullScreen}
                  open={dialogRestoreOpen}
                  onClose={handleRestoreDialogClose}
                  aria-labelledby="responsive-dialog-title"
                >
                  <DialogTitle id="responsive-dialog-title">
                    {"Wznowienie głosowania"}
                  </DialogTitle>
                  <DialogContent>
                    <DialogContentText>
                      Czy na na pewno chcesz wznowić głosowanie "
                      {restoredVoting ? restoredVoting.title : "-"}"?
                    </DialogContentText>
                    <TextField
                      multiline
                      error={restoreReasonError?.length > 0}
                      helperText={restoreReasonError}
                      margin="dense"
                      id="restorereason"
                      value={restoreReason}
                      onChange={handleRestoreReasonChange}
                      label="Uzasadnienie wznowienia"
                      type="text"
                      fullWidth
                    />
                  </DialogContent>
                  <DialogActions>
                    <Button
                      autoFocus
                      onClick={handleRestoreDialogClose}
                      color="primary"
                    >
                      Nie
                    </Button>
                    <Button onClick={handleRestore} color="primary" autoFocus>
                      Tak
                    </Button>
                  </DialogActions>
                </Dialog>
              </Container>
            </Page>
          </KmTabPanel>
        </Paper>
      </Container>
    </Page>
  );
};

const mapDispatchToProps = (dispatch) => ({
  setLogoutUser: () => dispatch(actions.setLogoutUser()),
  enableGlobalLoader: () => dispatch(actions.enableGlobalLoader()),
  disableGlobalLoader: () => dispatch(actions.disableGlobalLoader()),
});

export default connect(null, mapDispatchToProps)(Votings);
